import React from "react";
import { useDispatch } from "react-redux";
import { search } from "../redux/search_bar/actions";

export default function SearchField() {
  const dispatch = useDispatch();
  let timeOutId;
  const handler = (e) => {
    if (timeOutId) {
      clearTimeout(timeOutId);
    }
    timeOutId = setTimeout(() => {
      dispatch(search(e.target.value));
    }, 1200);
  };
  return (
    <div className="border mt-6 border-slate-200 flex items-center w-11/12 lg:w-1/2 mx-auto bg-gray-50 h-12 px-5 rounded-lg text-sm ring-emerald-200">
      <input
        id="search_field"
        className="outline-none border-none bg-gray-50 h-full w-full mr-2"
        type="search"
        name="search"
        placeholder="Search"
        onChange={handler}
      />
      <img
        className="inline h-6 cursor-pointer"
        src="assets/search.svg"
        alt="Search"
      />
    </div>
  );
}
